// Detect Vite dev mode (works even when frontend is accessed via LAN IP)
const isDev = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV;

// Auto-detect local loopback when not running under Vite dev server
const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isLocal = isDev || isLocalHost;

// Get URLs from environment variables (set in .env or .env.production)
// Vite exposes env vars prefixed with VITE_
let ENV_BACKEND_URL = import.meta.env.VITE_BACKEND_URL || '';
let ENV_FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL || '';

// Ensure URLs have protocol - common mistake is forgetting https://
if (ENV_BACKEND_URL && !ENV_BACKEND_URL.startsWith('http://') && !ENV_BACKEND_URL.startsWith('https://')) {
  ENV_BACKEND_URL = 'https://' + ENV_BACKEND_URL;
}
if (ENV_FRONTEND_URL && !ENV_FRONTEND_URL.startsWith('http://') && !ENV_FRONTEND_URL.startsWith('https://')) {
  ENV_FRONTEND_URL = 'https://' + ENV_FRONTEND_URL;
}

// Fallback URLs (used if env vars are not set)
// IMPORTANT: Update these for your project or use environment variables
const FALLBACK_PROD_BACKEND = 'https://asmarshop-backend.up.railway.app';
const FALLBACK_PROD_FRONTEND = 'https://asmarshop-frontend.vercel.app';
const FALLBACK_LOCAL_BACKEND = 'http://127.0.0.1:8000';
const FALLBACK_LOCAL_FRONTEND = 'http://localhost:5173';

// Determine the backend and frontend URLs
const BACKEND_URL = ENV_BACKEND_URL || (isLocal ? FALLBACK_LOCAL_BACKEND : FALLBACK_PROD_BACKEND);
const FRONTEND_BASE = ENV_FRONTEND_URL || (isLocal ? FALLBACK_LOCAL_FRONTEND : FALLBACK_PROD_FRONTEND);

// Export URLs - ensure trailing slash for API paths
export const SERVER_URL = BACKEND_URL.replace(/\/$/, ''); // No trailing slash
export const BASE_URL = `${SERVER_URL}/api/v1/`;
export const API_BASE_URL = BASE_URL;
export const FRONTEND_URL = FRONTEND_BASE.replace(/\/$/, ''); // No trailing slash

